export default "__VITE_ASSET__6045a879__"